import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import userReducer from './reducers/userSlice';
import targetGroupReducer from './reducers/targetGroupSlice';
import studentTourReducer from './reducers/studentTourSlice';
import studentSkillsReducer from './reducers/studentSkillsSlice';
import studentSkillsForAllRoadmapsReducer from './reducers/studentSkillsForAllRoadmapsSlice';
import filterReducer from './reducers/filterSlice';
import accessTokenReducer from './reducers/accessTokenSlice';
import suggestedViewReducer from './reducers/suggestedViewSlice';
import filterCountReducer from './reducers/filterCountSlice';
import unitReducer from './reducers/unitSlice';
import reportsFilterRedux from './reducers/filterReportsSlice';
import studentSkillAfterTakeAssessmentSliceReducer from './reducers/studentSkillAfterTakeAssessmentSlice';
import csvProcessReducer from './reducers/csvProcessSlice';
import teacherDashboardFilterReducer from './reducers/teacherDashboardFiltersSlice';
import filterReportHubReducer from './reducers/filterReportHubSlice';
import reportHubQuerysInProgressReducer from './reducers/reportHubQuerysInProgress';
import assignmentSkillReducer from './reducers/assignmentSelectedSkillSlice';
import exitSlipModalReducer from './reducers/exitSlipModalSlice';
import filterExitSlipReducer from './reducers/filterExitSlipSlice';
import exitSlipFinishedReducer from './reducers/exitSlipStudentFinishedSlice';
import exitSlipDoneCountReducer from './reducers/exitSlipDoneCountSlice';
import exitSlipPendingFinishReducer from './reducers/exitSlipPendingFinishSlice';
import exitSlipEarnedSkillsReducer from './reducers/exitSlipEarnedSkillsSlice';
import exitSlipUnlockedSkillsReducer from './reducers/exitSlipUnlockedSkillsSlice';
import exitSlipSkillProgressReducer from './reducers/exitSlipSkillProgressSlice';
import exitSlipSkillEarningReducer from './reducers/exitSlipSkillEarningSlice';
import diagnosticReportFiltersReducer from './reducers/filterDiagnosticReport';
import individualStudentReportReducer from './reducers/individualStudentReportSlice';
import brainBreakReducer from './reducers/brainBreakSlice';
import teacherIntroReducer from './reducers/teacherIntroSlice';
import classIconsReducer from './reducers/classIconsSlice';
import hiddenClassesReducer from './reducers/hiddenClassesSlice';
import diagnosticResetReducer from './reducers/diagnosticResetSlice';
import focusReducer from './reducers/focusSlice';
import globalClassFilterReducer from './reducers/globalClassFilterSlice';
import pageTitleReducer from './reducers/pageTitleSlice';

const rootReducer = combineReducers({
  user: userReducer,
  targetGroup: targetGroupReducer,
  studentTour: studentTourReducer,
  studentSkills: studentSkillsReducer,
  filter: filterReducer,
  exitSlip: filterExitSlipReducer,
  accessToken: accessTokenReducer,
  suggestedView: suggestedViewReducer,
  unit: unitReducer,
  reportsFilter: reportsFilterRedux,
  studentSkillAfterTakeAssessment: studentSkillAfterTakeAssessmentSliceReducer,
  filterCount: filterCountReducer,
  studentSkillsForAllRoadmaps: studentSkillsForAllRoadmapsReducer,
  csvProcess: csvProcessReducer,
  teacherDashboardFilter: teacherDashboardFilterReducer,
  reportHubFilter: filterReportHubReducer,
  reportHubQuerysInProgress: reportHubQuerysInProgressReducer,
  assignmentSkill: assignmentSkillReducer,
  exitSlipModal: exitSlipModalReducer,
  exitSlipFinished: exitSlipFinishedReducer,
  exitSlipDoneCount: exitSlipDoneCountReducer,
  exitSlipPendingFinish: exitSlipPendingFinishReducer,
  exitSlipEarnedSkills: exitSlipEarnedSkillsReducer,
  exitSlipUnlockedSkills: exitSlipUnlockedSkillsReducer,
  exitSlipSkillProgress: exitSlipSkillProgressReducer,
  exitSlipSkillEarning: exitSlipSkillEarningReducer,
  diagnosticReportFilters: diagnosticReportFiltersReducer,
  individualStudentReport: individualStudentReportReducer,
  brainBreak: brainBreakReducer,
  teacherIntro: teacherIntroReducer,
  classIcons: classIconsReducer,
  hiddenClasses: hiddenClassesReducer,
  diagnosticReset: diagnosticResetReducer,
  focus: focusReducer,
  globalClassFilter: globalClassFilterReducer,
  pageTitle: pageTitleReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
